<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      name
      status
      btn-add
      score-start
      score-end
      @handleAdd="handleAdd"
      @handleSearch="getData"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column label="商品图" align="center" width="120">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 120px;"
            :src="serverUrl + scope.row.image"
            :preview-src-list="getImgPreviewList(scope.row.image)"
          ></el-image>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="140">
        <template slot-scope="scope">
          <el-button
            @click="showDialogContent(scope.row)"
            type="text"
            size="mini"
          >
            详情
          </el-button>
          <el-button @click="handleEdit(scope.row)" type="text" size="mini">
            编辑
          </el-button>
          <el-button
            @click="handleEnabled(scope.row)"
            type="text"
            :style="{ color: scope.row.status === 1 ? 'red' : '' }"
            size="mini"
          >
            {{ scope.row.status === 1 ? "禁用" : "启用" }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--新增Dialog-->
    <el-dialog
      title="添加商品"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item label="商品名" prop="name" label-width="100px">
          <el-input
            v-model="form.name"
            size="medium"
            placeholder="商品名"
          ></el-input>
        </el-form-item>

        <el-form-item label="规格" prop="secondName" label-width="100px">
          <el-input
            type="textarea"
            autosize
            placeholder="例：500ml/瓶"
            v-model="form.secondName"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="描述" label-width="100px">
          <el-input
            type="textarea"
            autosize
            placeholder="描述"
            v-model="form.description"
          >
          </el-input>
        </el-form-item> -->

        <el-form-item
          label="所需积分"
          prop="score"
          style="text-align: left"
          label-width="100px"
        >
          <el-input-number
            v-model="form.score"
            size="medium"
            :min="0"
            placeholder="所需积分"
          ></el-input-number>
        </el-form-item>

        <el-form-item
          label="图片"
          style="text-align: left"
          prop="image"
          label-width="100px"
        >
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="overwriteDefault"
          >
            <img
              v-if="form.image"
              :src="serverUrl + form.image"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <p>点击上传</p>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item label="描述" label-width="100px">
          <quill-editor
            style="text-align: left;"
            v-model="form.description"
            ref="myQuillEditor"
            :options="editorOption"
            @focus="onEditorFocus($event)"
            @blur="onEditorBlur($event)"
            @change="onEditorChange($event)"
          ></quill-editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      title="详情"
      :close-on-click-modal="false"
      :visible.sync="dialogContentVisible"
    >
      <Details :detail="dialogContent" :type="'product'"></Details>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { downloadFile } from "@/assets/http/utils"
import Details from "@/components/details/index"
import Axios from "axios"
import apiUrl from "@/assets/http/apiUrl"
import { quillEditor } from "vue-quill-editor"
import "quill/dist/quill.snow.css"
import { quillRedefine } from "vue-quill-editor-upload"
export default {
  name: "productManager",
  components: {
    quillEditor,
    quillRedefine,
    Details,
  },
  data() {
    let Self = this

    // 表单验证
    let validateMobile = (rule, value, callback) => {
      if (/^1[3456789]\d{9}$/.test(value)) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("手机号验证失败"))
      }
    }
    let validateIdCard = (rule, value, callback) => {
      if (
        /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          value
        )
      ) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("身份证号验证失败"))
      }
    }
    let validateAvatar = (rule, value, callback) => {
      if (Self.form.image !== "") {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("请上传图片"))
      }
    }

    return {
      // 页面初始数据
      totalElements: 10,
      totalPages: 1,
      size: 10,
      page: 1,

      serverUrl: apiUrl.ServerUrl,

      // 搜索栏初始化
      searchForm: {
        name: "",
        status: "",
        scoreStart: "",
        scoreEnd: "",
      },

      // 表头初始化
      tableHeader: {
        name: "名称",
        secondName: "规格",
        // description: "描述",
        score: "所需积分",
        statusName: "状态",
      },

      // 表格数据
      tableData: [],

      // dialog可见性
      dialogFormVisible: false,
      dialogUploadVisible: false,

      // 上传文件列表
      file: "",

      // 新增表单
      form: {
        uid: "",
        name: "",
        secondName: "",
        description: "",
        image: "",
        score: "",
      },

      // 表单验证规则
      rules: {
        name: {
          required: true,
          message: "请输入名称",
          trigger: "blur",
        },
        secondName: {
          required: true,
          message: "请输入商品规格",
          trigger: "blur",
        },
        score: {
          required: true,
          message: "请输入所需兑换积分",
          trigger: "blur",
        },
        image: {
          required: true,
          validator: validateAvatar,
          trigger: "blur",
        },
      },

      // 头像上传初始化
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      // 控制详情弹窗
      dialogContentVisible: false,
      dialogContent: "",
    }
  },
  methods: {
    /*图片预览*/
    getImgPreviewList(url) {
      let arr = new Array(this.serverUrl + url)
      return arr
    },

    /*请求数据
     * */
    getData() {
      this.request({
        url: "/manager/product/findProduct",
        method: "get",
        params: {
          page: this.page,
          size: this.size,

          name: this.searchForm.name,
          scoreStart: this.searchForm.scoreStart,
          scoreEnd: this.searchForm.scoreEnd,
          status: this.searchForm.status,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages

          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*更改单页数据数量
     * */
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转
     * */
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    // 准备富文本编辑器
    onEditorReady(editor) {},
    // 富文本编辑器 失去焦点事件
    onEditorBlur(editor) {},
    // 富文本编辑器 获得焦点事件
    onEditorFocus(editor) {},
    // 富文本编辑器 内容改变事件
    onEditorChange(editor) {
      this.form.conditions = editor.html
    },

    /*启用/禁用
     * */
    handleEnabled(rowData) {
      let status = rowData.status === 1 ? 2 : 1
      this.request({
        url: "/manager/product/updateStatus",
        data: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*编辑
     * */
    handleEdit(rowData) {
      this.form = {
        ...rowData,
      }
      this.dialogFormVisible = true
    },

    /*添加商户前的处理
     * 需要将options中的'全部'一项给去掉
     * 因为是必填项*/
    handleAdd() {
      this.dialogFormVisible = true
    },

    /*删除
     * */
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/product/deleteProduct",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },
    // 查看详情
    showDialogContent(rowData) {
      this.dialogContentVisible = true
      this.dialogContent = rowData
    },

    /*dialog提交
     * */
    dialogConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.dialogFormVisible = false

          this.request({
            url: "/manager/product/addOrUpdateProduct",
            data: {
              uid: this.form.uid,

              name: this.form.name,
              secondName: this.form.secondName,
              description: this.form.description,
              image: this.form.image,
              score: this.form.score,
            },
            method: "post",
          })
            .then(res => {
              if (res.data.status === "BAD_REQUEST") {
                this.$message.warning(res.data.message)
              }

              this.getData()
              this.form = {}
            })
            .catch(err => {})
        }
      })

      this.optionGroup.unshift({
        name: "全部",
        uid: "",
      })
    },

    /*dialog取消
     * */
    dialogCancel() {
      this.form = {
        uid: "",
        name: "",
        secondName: "",
        description: "",
        image: "",
        score: "",
      }
      this.dialogFormVisible = false
    },

    /*覆盖默认上传请求
     * */
    overwriteDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e)
      tmpFile.append("folder", "product")
      // this.file = tmpFile
      Axios.post(apiUrl.server + "/manager/upload/uploadFile", tmpFile)
        .then(res => {
          this.form.image = res.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    uploadCancel() {
      this.dialogUploadVisible = false
      this.form = {}
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
  margin-right: 10px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
</style>
